import React from 'react'
import "./Footer.scss"

const Footer = () => {
  return (
    <div className='footer_main pb-5'>
        <div className="container pt-5">
            <div className="row">
                <div className="col">
                    <div className="footer_nav_cont mt-0 mt-md-5 d-flex flex-column flex-md-row justify-content-center align-items-center">
                        <h2 className='mx-4 my-2'><a href="#home">Home</a></h2>
                        <h2 className='mx-4 my-2'><a href="#Aboutme">About</a></h2>
                        <h2 className='mx-4 my-2'><a href="#MySkills">Skills</a></h2>
                        <h2 className='mx-4 my-2'><a href="#Projects">Projects</a></h2>
                        <h2 className='mx-4 my-2'><a href="#GetInTouch">Contact</a></h2>
                    </div>
                    <h2 className='my-5'>Thank you for visiting my portfolio! Have a nice day.</h2>
                    <h2 className='my-5'>© Copyright 2023. All Rights Reserved</h2>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Footer